<template>

  <section class="o-section">
    <div class="o-section__wrapper is-bottom-left" ref="wrapper">

      <div :class="{
        'o-section__text': true,
        'anim-text-scene-3': lang === 'fr'
      }"
        v-if="active">
        <div ref="textA" data-scene="3a">
          <div v-for="(line, index) in copy.top" v-html="line" :key="`top-${index}`"></div>
        </div>
      </div>

      <div class="o-section__figure-wrapper" v-if="active">
        <figure class="o-section__figure" ref="figureC" data-scene="3c">
          <Img :src="require('@/assets/scene3/spread3_c.png')" filename="spread3_c" />
        </figure>

        <figure class="o-section__figure" ref="figureA" data-scene="3a">
          <Img :src="require('@/assets/scene3/spread3_a.png')" filename="spread3_a" />
        </figure>

        <figure class="o-section__figure anim-scene-3" ref="figureB2" data-scene="3b2">
          <Img :src="require('@/assets/scene3/spread3_b2.png')" filename="spread3_b2" />
        </figure>

        <figure class="o-section__figure" ref="figureB" data-scene="3b">
          <Img :src="require('@/assets/scene3/spread3_b.png')" filename="spread3_b" />
        </figure>
      </div>
    </div>
  </section>

</template>

<script>
import { mapState } from 'vuex'
import Img from '@/components/Img'

export default {
  name: 'Scene3',
  props: ['options', 'active', 'copy', 'disableBlur'],

  mounted () {
    this.$root.$on('startScene3', () => {
      this.init()
    })
  },

  methods: {
    init () {
      this.$anime({
        targets: this.$refs.figureA,
        translateY: ['60px', '0'],
        duration: this.options.durationLarge,
        easing: this.options.easing
      })

      this.$anime({
        targets: [this.$refs.figureB, this.$refs.figureB2],
        translateY: ['-40px', '0'],
        duration: this.options.durationLarge,
        easing: this.options.easing
      })

      this.$anime({
        targets: this.$refs.figureB2.querySelector('div'),
        rotate: ['-10deg', '2deg'],
        duration: this.options.durationSmall,
        loop: true,
        direction: 'alternate',
        easing: this.options.easing
      })

      if (this.disableBlur) {
        this.$anime({
          targets: [this.$refs.figureB, this.$refs.figureB2],
          opacity: [0, 1],
          duration: this.options.durationRegular,
          easing: this.options.easing
        })

        this.$anime({
          targets: this.$refs.figureC,
          opacity: [0, 1],
          translateY: ['-40px', '0'],
          translateX: ['20px', '0'],
          delay: 400,
          duration: this.options.durationRegular,
          easing: this.options.easing
        })
      } else {
        this.$anime({
          targets: [this.$refs.figureB, this.$refs.figureB2],
          filter: ['blur(10px)', 'blur(0px)'],
          duration: this.options.durationRegular,
          easing: this.options.easing
        })

        this.$anime({
          targets: this.$refs.figureC,
          filter: ['blur(25px)', 'blur(0px)'],
          translateY: ['-40px', '0'],
          translateX: ['20px', '0'],
          delay: 400,
          duration: this.options.durationRegular,
          easing: this.options.easing
        })
      }
    }
  },

  computed: mapState({
    lang: state => state.language
  }),

  components: {
    Img
  }
}
</script>
